import $ from 'jquery';

// todo: change from .wysiwyg to .js-wysiwyg?

$('.wysiwyg').each(function (index, wysiwyg) {
  const $wysiwyg = $(wysiwyg);

  $wysiwyg
    .find('p:has(a:not([class]):only-child)')
    .each(function (index, paragraph) {
      const $paragraph = $(paragraph);
      const $link = $paragraph.find('a');
      if ($paragraph.text() === $link.text()) {
        $link.addClass('navlink');
      }
    });
});
